module.exports = __webpack_public_path__ + "graphics/player-prev.ckh.35b9d91a76011d24488bfbd90ac29166.svg";